// extracted by mini-css-extract-plugin
export default {"navebar":"NaveBarPaginas_navebar__65QX3","inicio":"NaveBarPaginas_inicio__KkZlh"};